// 1. React and core hooks
import { useEffect } from 'react';

// 2. External libraries
import { useClerk } from '@clerk/clerk-react';

// 3. Internal components
import { FullPageSpinner } from '~/components/common/FullPageSpinner';

/**
 * Sign out page that automatically signs out the user when visited.
 * Useful for testing and resetting auth state.
 */
export function SignOutPage() {
  const { signOut } = useClerk();

  useEffect(() => {
    void signOut({ redirectUrl: '/sign-in' });
  }, [signOut]);

  return <FullPageSpinner message="Signing out..." />;
}
